import { call, put, takeEvery } from "redux-saga/effects"
import { FORM_NAMES } from "constants/index"

import {
  ADD_TAGS,
  CONNECT_USER_TO_PRISM,
  CREATE_ADMIN,
  CREATE_USER,
  DELETE_PENDING_USERS,
  DELETE_USER,
  GET_CUSTOMERS,
  GET_USER_META_TAGS,
  REMOVE_USER_TAG,
  SEND_INVITE,
  SET_USER_BLOCK_STATUS,
  UPDATE_CUSTOMER_DATA,
} from "./actionTypes"
import {
  getCustomersSuccess,
  getCustomersFail,
  sendInviteSuccess,
  sendInviteFail,
  createAdminFail,
  createUserFail,
  createAdminSuccess,
  createUserSuccess,
  hideCreateModal,
  hideBulkModal,
  addTagsFailed,
  addTagsSuccess,
  hideAddTagModal,
  getUserMetaTagsFailed,
  getUserMetaTagsSuccess,
  updateCustomerDataFailed,
  updateCustomerDataSuccess,
  connectUserToPrismFailed,
  connectUserToPrismSuccess,
  removeUserTagSuccess,
  hideRemoveUserTagModal,
  removeUserTagFailed,
  deletePendingUsersFailed,
  deletePendingUsersSuccess,
  hideDeletePendingUsersModal,
  deleteUserFailed,
  deleteUserSuccess,
  setUserBlockStatusSuccess,
  setUserBlockStatusFailed,
} from "./actions"

import { del, get, post } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { getApiErrorMessage, getFormDataFromJSON, showToast } from "utils"
import { submit } from "redux-form"

function* fetchPeople({ payload: params }) {
  try {
    const response = yield get(url.GET_CUSTOMER_URL, params)
    yield put(getCustomersSuccess(response))
  } catch (error) {
    yield put(getCustomersFail(error))
    showToast("error", error, "Error")
  }
}

function* sendInviteSaga({ payload: values }) {
  // let formData = getFormDataFromJSON(values)
  try {
    const response = yield post(url.SEND_APP_INVITES_URL, values)
    yield put(sendInviteSuccess(response))
    showToast("success", "Invite(s) sent!", "Success")
  } catch (error) {
    yield put(sendInviteFail(error))
    showToast("error", error, "Error")
  }
}

function* createUser({ payload }) {
  try {
    yield post(url.ADMIN_USERS_CREATE_MULTIPLE_URL, payload)
    yield put(createUserSuccess())
    yield put(hideCreateModal())
    yield put(hideBulkModal())
    yield put(submit(FORM_NAMES.USERS_FILTER))
    showToast("success", "User created!", "Success")
  } catch ({ response }) {
    const message = getApiErrorMessage(response, false)
    showToast("error", message, "Error")
    yield put(createUserFail(message))
  }
}

function* createAdmin({ payload }) {
  const formData = getFormDataFromJSON(payload)
  try {
    yield post(url.ADMIN_USER_URL, formData)
    yield put(createAdminSuccess())
    yield put(hideCreateModal())
    yield put(submit(FORM_NAMES.USERS_FILTER))
    showToast("success", "User created!", "Success")
  } catch ({ response }) {
    const message = getApiErrorMessage(response, false)
    showToast("error", message, "Error")
    yield put(createAdminFail(message))
  }
}

function* addTags({ payload: params }) {
  try {
    const response = yield post("/admin/users/add-tags", params?.values)
    yield put(addTagsSuccess(response))
    showToast("success", "Tags added!", "Success")
    yield put(hideAddTagModal())
    if (params?.callbackParams) {
      const customers = yield get(url.GET_CUSTOMER_URL, {
        params: params?.callbackParams,
      })
      yield put(getCustomersSuccess(customers))
    }
  } catch (error) {
    yield put(addTagsFailed(error))
    yield put(hideAddTagModal())
    showToast("error", error, "Error")
  }
}

function* getUserMetaTags({ payload: params }) {
  try {
    const response = yield get(url.USER_META_TAGS, { params })
    yield put(getUserMetaTagsSuccess(response))
  } catch (error) {
    yield put(getUserMetaTagsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateCustomerData({ payload: params }) {
  try {
    const response = yield post(
      `/user/${params?.userId}`,
      getFormDataFromJSON(params?.customerData)
    )
    yield post("/user-meta-tags", params?.tags)
    yield put(updateCustomerDataSuccess(response))
    if (params?.callback) {
      params.callback()
    }
    showToast("success", "Social profile updated!", "Success")
  } catch (error) {
    yield put(updateCustomerDataFailed(error))
    showToast("error", error, "Error")
  }
}

function* connectUserToPrism({ payload: params }) {
  try {
    const response = yield post("/connect-user-to-prism", params)
    yield put(connectUserToPrismSuccess(response))
    showToast("success", response?.message || "", "Success")
  } catch ({ response }) {
    yield put(connectUserToPrismFailed(response))
    showToast("error", response?.data?.error || "Error", "Error")
  }
}

function* removeUserTag({ payload: params }) {
  try {
    const response = yield post("/admin/users/remove-tags", params?.values)
    yield put(removeUserTagSuccess(response))
    showToast("success", "Tags removed!", "Success")
    yield put(hideRemoveUserTagModal())
    if (params?.callbackParams) {
      const customers = yield get(url.GET_CUSTOMER_URL, {
        params: params?.callbackParams,
      })
      yield put(getCustomersSuccess(customers))
    }
  } catch (error) {
    yield put(removeUserTagFailed(error))
    yield put(hideRemoveUserTagModal())
    showToast("error", error, "Error")
  }
}

function* deletePendingUsers({ payload: params }) {
  try {
    yield post("/admin/users/delete-pending", params)
    yield put(deletePendingUsersSuccess())
    yield put(hideDeletePendingUsersModal())
    showToast(
      "success",
      "User(s) are being deleted! Please refresh to see the most recent data.",
      "Success"
    )
  } catch (error) {
    yield put(deletePendingUsersFailed(error))
    yield put(hideDeletePendingUsersModal())
    showToast("error", error, "Error")
  }
}

function* deleteUser({ payload: params }) {
  try {
    const response = yield del(`/user/${params?.userId}`)
    yield call(fetchPeople, {
      payload: { params: { ...params?.callbackParams } },
    })
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFailed(error))
    showToast("error", error, "Error")
  }
}

function* setUserBlockStatus({ payload: params }) {
  try {
    const response = yield post(`/admin/user/block/${params?.userId}`, params?.data)
    yield call(fetchPeople, {
      payload: { params: { ...params?.callbackParams } },
    })
    yield put(setUserBlockStatusSuccess(response))
  } catch (error) {
    yield put(setUserBlockStatusFailed(error))
    showToast("error", error, "Error")
  }
}

function* peopleSaga() {
  yield takeEvery(GET_CUSTOMERS, fetchPeople)
  yield takeEvery(SEND_INVITE, sendInviteSaga)
  yield takeEvery(CREATE_USER, createUser)
  yield takeEvery(CREATE_ADMIN, createAdmin)
  yield takeEvery(ADD_TAGS, addTags)
  yield takeEvery(GET_USER_META_TAGS, getUserMetaTags)
  yield takeEvery(UPDATE_CUSTOMER_DATA, updateCustomerData)
  yield takeEvery(CONNECT_USER_TO_PRISM, connectUserToPrism)
  yield takeEvery(REMOVE_USER_TAG, removeUserTag)
  yield takeEvery(DELETE_PENDING_USERS, deletePendingUsers)
  yield takeEvery(DELETE_USER, deleteUser)
  yield takeEvery(SET_USER_BLOCK_STATUS, setUserBlockStatus)
}

export default peopleSaga
